export default __webpack_public_path__ + "static/media/90.27bcf360.jpeg";